import { useEffect, useState } from "react";
import { api } from "@/lib/pfc";

export default function Press() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/press").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-5 lg:px-10 py-14" data-testid="press-page">
      <div className="mb-12">
        <div className="label text-pfc-gold mb-3">Press Releases</div>
        <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl text-white uppercase leading-[0.9]">
          Official <span className="gold-text">Announcements</span>
        </h1>
      </div>
      <div className="space-y-6" data-testid="press-list">
        {items.map((p) => (
          <div key={p.release_id} className="pfc-card p-8" data-testid={`press-${p.release_id}`}>
            <div className="label text-pfc-gold mb-3">{p.organization} · {new Date(p.created_at).toLocaleDateString()}</div>
            <h3 className="font-display text-3xl text-white uppercase leading-tight">{p.title}</h3>
            <p className="text-white/70 mt-4 font-body leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
